import contacts from "./contacts";
import admin from "./admin";

export default {
  contacts,
  admin
}



// WEBPACK FOOTER //
// ./src/services/api/index.js